import { Prompt } from '@ai-platform/utils';

import { PromptCard } from '../PromptCard';
import { PromptCardSkeleton } from '../PromptCardSkeleton';

export const skeletonItems = Array.from({ length: 10 }, (_, index) => index);

export const renderPrompt = (item: Prompt) => {
    return <PromptCard size="small" prompt={item} fromCollection />;
};

export const renderPromptSkeleton = () => {
    return <PromptCardSkeleton size="small" />;
};
